import { createSlice } from "@reduxjs/toolkit";

export const PendingWorkflowSlice = createSlice({
    name : 'pending_workflow',
    initialState : {
        value : []
    },
    reducers : {
        updatePendingWorkflow : (state, action) => {
            state.value = action.payload
        }
    }
});

export const { updatePendingWorkflow } = PendingWorkflowSlice.actions

export default PendingWorkflowSlice.reducer